/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Check auth user data access
 *
 * @author Anton Panasenko
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.3.1
 */

import get from 'lodash/get';
import { select } from 'redux-saga/effects';

import { makeSelectAuthUserData } from '../../../pages/PageAuth/selectors/authSelectors';
import { IAuthUser } from '../../../pages/PageAuth/types/authTypes';
import { Access } from '../constants/guard/accessGuardConstants';
import { AccessComponentKeyEnum } from '../constants/guard/guardConstants';

export function* checkGuardAuthUserDataSaga(componentKey: AccessComponentKeyEnum) {
    const authUserData: IAuthUser = yield select(makeSelectAuthUserData());
    const guardAuthUserData = get(Access[componentKey], 'authUserData');
    if (guardAuthUserData) {
        return authUserData[guardAuthUserData.name] === guardAuthUserData.isEnabled;
    }
    return true;
}
